import React from "react";
import { View, ScrollView, KeyboardAvoidingView } from "react-native";

import Utils, {
  hasItems,
  isAndroid,
  isWeb,
  navigate,
} from "../../../../../helpers/utils";
import appStyles from "../../../../appStyles";
import ElementPickerFabButton from "./ElementPickerFabButton";
import ElementsHelper from "../../../elements/ElementsHelper";
import ElementsList from "../../../elements/list/ElementsList";
import Header from "../../../common/header/index";
import LoadingIndicator from "../../../common/LoadingIndicator";
import Search from "../../../common/search-bar/Search";
import appPages from "../../../../../appPages";

export default class TimerElementPicker extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: true,
      elements: [],
    };
  }

  componentDidMount = async () => {
    this.filterResults();
  };

  filterByKeyword = ({ term }) => {
    this.filterResults({ term });
  };

  filterResults = (filters = { sortBy: "name" }) => {
    this.setState((state) => ({
      ...state,
      isLoading: false,
      filters,
      elements: ElementsHelper.filterResults(this.controller, filters),
    }));
  };

  onElementSelected = (el) => {
    Utils.LOCAL_CACHE["timer_element"] = el;
    this.controller.changePage("rn:home_card");
  };

  render() {
    const { isLoading, showTutorials, elements } = this.state;

    return (
      <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
        <KeyboardAvoidingView
          style={appStyles.kbViewNoFooter}
          behavior="height"
          keyboardVerticalOffset={isAndroid ? 20 : 0}
        >
          <Header
            title="Choose Element"
            subTitle="Choose an Element for your timer"
            hideAvatar
            controller={this.controller}
            returnPage={appPages.homePage}
          />

          {isLoading ? (
            <LoadingIndicator isLoading={isLoading} />
          ) : (
            <ScrollView
              style={appStyles.scrollView}
              contentContainerStyle={appStyles.scrollViewContent}
            >
              {hasItems(elements) ? (
                <ElementsList
                  elements={elements}
                  controller={this.controller}
                  showTutorials={showTutorials}
                  onElementSelected={this.onElementSelected}
                />
              ) : null}
            </ScrollView>
          )}

          <View style={appStyles.footerOptions}>
            <ElementPickerFabButton style={{ bottom: isWeb ? 60 : 50 }} />

            <Search
              placeholder="Search an element"
              controller={this.controller}
              filterResults={this.filterByKeyword}
              searchString={this.state.searchString}
              style={{ zIndex: 100 }}
            />
          </View>
        </KeyboardAvoidingView>
      </View>
    );
  }
}
